import "core-js/modules/es6.regexp.replace";
import Vue from 'vue';
export function removeHttp(src) {
  return src.replace(/^http(s?):/, '');
}
export function mixinRemoveHttp() {
  Vue.mixin({
    filters: {
      removeHttp: removeHttp
    },
    methods: {
      removeHttp: removeHttp
    }
  });
}